export class StreamApiError extends Error {
    public readonly status: number;
    public readonly body: string;

    constructor(status: number, body: string) {
        super(`Stream API error ${status}`);
        this.name = 'StreamApiError';
        this.status = status;
        this.body = body;
    }
}

export class StreamParseError extends Error {
    public readonly status: number;
    public readonly body: string;

    constructor(status: number, body: string) {
        super(`Stream API parse error (status ${status})`);
        this.name = 'StreamParseError';
        this.status = status;
        this.body = body;
    }
}
